import _ from 'lodash';
import { objectEntries } from '../../../../common/shared/utils/object';
import { AccountsChargesSelectionState } from '../../../models/accounts/chargesSelection';
import { GroupedAccountWithMappedBalanceAndChargesData } from '../balanceAndCharges/index';

export const accountChargesSelectionInitialDataMapper = (
    mappedAccounts: GroupedAccountWithMappedBalanceAndChargesData[]
): AccountsChargesSelectionState => {
    const initialData: AccountsChargesSelectionState = {
        amountSelection: {},
        activitySelection: {},
    };

    return mappedAccounts.reduce((acc, { id: accountId, groupedData }) => {
        if (!accountId) {
            return acc;
        }

        const groupEntries = objectEntries(groupedData)
            .map(([codeGroup, data]) => ({ codeGroup, data }));

        for (const { codeGroup, data } of groupEntries) {
            for (const [debtType, { atomicServices, separatableServices }] of objectEntries(data.mappedData)) {
                for (const [, servicesList] of objectEntries(separatableServices)) {
                    for (const { accountServiceId, endPeriodBalance } of servicesList) {
                        const amountSelection = Math.max(0, endPeriodBalance);
                        _.set(acc.amountSelection, [accountId, codeGroup, debtType, 'separatableServices', accountServiceId].map(String), amountSelection);

                        if (acc.activitySelection[accountId]?.[codeGroup]?.[debtType]?.separatableServices) {
                            acc.activitySelection[accountId][codeGroup][debtType]
                                .separatableServices.push(accountServiceId);
                        } else {
                            _.set(acc.activitySelection, [accountId, codeGroup, debtType, 'separatableServices'].map(String), [accountServiceId]);
                        }
                    }
                }

                for (const [, servicesList] of objectEntries(atomicServices)) {
                    for (const { accountServiceId, endPeriodBalance } of servicesList) {
                        const amountSelection = Math.max(0, endPeriodBalance);
                        _.set(acc.amountSelection, [accountId, codeGroup, debtType, 'separatableServices', accountServiceId].map(String), amountSelection);
                    }
                }

                if (Object.keys(atomicServices).length) {
                    const totalAmount = objectEntries(atomicServices).reduce((groupAcc, [, servicesList]) => {
                        return servicesList.reduce((listAcc, { endPeriodBalance }) => listAcc + Math.max(0, endPeriodBalance), groupAcc);
                    }, 0);

                    _.set(acc.amountSelection, [accountId, codeGroup, debtType, 'atomicServices'].map(String), totalAmount);
                    _.set(acc.activitySelection, [accountId, codeGroup, debtType, 'atomicServices'].map(String), true);
                }
            }
        }

        return acc;
    }, initialData);
};
